import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IPostTrxApprovalData {
  responseCode: "Succeed" | "Failed",
  responseMessage: string,
}

export const url = "/v1/smpltrxapproval";

export const putTrxApproval = async (
  payload: {
    trx_id: string,
    approval_number: string,
    status_approval: string,
    employee_email: string,
    reason_status: string,
    update_by: string
  },
): Promise<IPostTrxApprovalData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/approval`,
    method: "PUT",
    data: payload,
  });

  return data;
};
